import { X } from 'lucide-react'
import React from 'react'

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../components/dialog'
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '../components/drawer'
import { useIsMobile } from '../hooks/use-mobile'

type ResponsiveDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  children: React.ReactNode
  dialogClassname?: string
  drawerClassname?: string
}

const ResponsiveDialog = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  dialogClassname = '',
  drawerClassname = ''
}: ResponsiveDialogProps) => {
  const isDesktop = !useIsMobile()

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange} modal>
        <DialogContent className={`grid-rows-[auto_minmax(0,1fr)] ${dialogClassname}`}>
          <DialogHeader className="flex-none bg-background pr-6 gap-1">
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
          <div className="min-h-0 overflow-y-auto" tabIndex={-1}>
            {children}
          </div>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className={`max-h-[90dvh] flex flex-col ${drawerClassname}`}>
        <DrawerHeader className="flex-none bg-background pr-6">
          <DrawerTitle>{title}</DrawerTitle>
          {description && <DrawerDescription>{description}</DrawerDescription>}
          <DrawerClose asChild>
            <button className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none">
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </button>
          </DrawerClose>
        </DrawerHeader>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-4 md:px-6 md:pb-6" tabIndex={-1}>
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export { ResponsiveDialog }
